<template>
  <div class="logo-container">
    <div class="logo">
      <img src="../assets/Heart.png" class="scale3" srcset="../assets/HeartSmall.png 500w, ../assets/Heart.png 1000w" alt="">
      <img src="../assets/Title.png" class="scale1" srcset="../assets/TitleSmall.png 500w, ../assets/Title.png 1000w" alt="">
      <img src="../assets/Credit.png" style="position: relative;" srcset="../assets/CreditSmall.png 500w, ../assets/Credit.png 1000w" alt="">
      <img src="../assets/ReCollection.png" class="scale2" srcset="../assets/ReCollectionSmall.png 500w, ../assets/ReCollection.png 1000w">
      <img src="../assets/ReCollectionBanner.png" class="scale2" style="opacity: 0;" srcset="../assets/ReCollectionBannerSmall.png 500w, ../assets/ReCollectionBanner.png 1000w"> alt="Kingdom Hearts ReCollection Created by Televo">
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainLogo',
};
</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  padding-top: 3em;
}
@media screen and (max-width: 490px) {
  .logo-container {
    padding: 3.5em 0 2em;
    transform: scale(1.15);
  }
}
.logo {
  position: relative;
  width: 100%;
}
img {
  width: 100%;
  aspect-ratio: auto 2/1;
  position: absolute;
  left: 0;
  top: 0;
}
.scale1 { animation: scale1 7s infinite ease-in-out; }
@keyframes scale1 { 50% { transform: scale(1.025); filter: brightness(125%); } }
.scale2 { animation: scale2 7s infinite ease-in-out; }
@keyframes scale2 { 50% { transform: scale(1.05) translateY(-0.5%); filter: brightness(125%); } }
.scale3 { animation: scale3 7s infinite ease-in-out; }
@keyframes scale3 { 0% { opacity: 0.5; }
                    50% { transform: scale(1.15); opacity: 1; }
                    100% { opacity: 0.5; } }
</style>